module.exports = __webpack_public_path__ + "media/images/emoticons/pencil-02eca0008d62044894f2238ae361779c.gif";